import { isObjectLike } from './is-object-like.js';
import { type } from './type.js';

/**
 * @description
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * @example
 * ``` ts
 * isNumber(123);
 * // => true
 * isNumber(NaN);
 * // => true
 * isNumber(Number.MIN_VALUE);
 * // => true
 * isNumber('123');
 * // => false
 * ```
 *
 * @note
 * To exclude Infinity, -Infinity, and NaN, which are classified as numbers
 *
 * @param value The value to check.
 * @returns Returns true if value is a number, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-number
 */
export const isNumber = (value): value is number => {
  return (
    type(value) === 'number' ||
    (isObjectLike(value) &&
      Object.prototype.toString.call(value) == '[object Number]')
  );
};
